import React from "react";

/**
 * Contract Holder Program Performance "Contract Adherence" More Info Component
 * @returns {Element}
 * @constructor
 */
export default function ContractAdherence() {
  return (<tr className="extra-info">
    <td colSpan={6}>
      <div>
        <h6 className="bold">Contract Adherence</h6>
        <p>The Contract Adherence rating refers to the Contract holder’s ability to adhere to all contractual require
          including but not limited following the correct quoting procedures and SEWP order fulfillment guidelines.</p>

        <ul className="performance-desc-range">
          <li className="excellent">Excellent - 0-2 / 100%-91% verified</li>
          <li className="very-good">Very Good - 3 / 90%-81% verified</li>
          <li className="good">Good - 4 / 80%-71% verified</li>
          <li className="fair">Fair - 5 / 70%-61% verified</li>
          <li className="poor">Poor - &#62;= 6 / &#60;= 60%</li>
        </ul>

        <ul>
          <li><strong>Excellent</strong> = &#60;= 2 issues occurred, and/or 100% - 91% verified orders</li>
          <li><strong>Very Good</strong> = 3 issues occurred and contract holder quickly resolved situation, or issues
            occurred and several not resolved and/or were repeated, and /or 90% - 81% verified orders
          </li>
          <li><strong>Good</strong> = 4 issues occurred and contract holder quickly resolved situation, or issues
            occurred and several not resolved and/or were repeated, and /or 80% - 71% verified orders
          </li>
          <li><strong>Fair</strong> = 5 issues occurred and contract holder quickly resolved situation, or issues
            occurred and several not resolved and/or were repeated, and /or 70% - 61% verified orders
          </li>
          <li><strong>Poor</strong> = &#62;= 6 issues occurred and/or request to fix issues continuously ignored, and
            or  &#60;= 60% verified orders
          </li>
          <li><strong>Neutral</strong> = Contract Holder has not received any orders or performed any work on the SEWP
            contracts to date
          </li>
        </ul>
      </div>
    </td>
  </tr>);
}